import * as z from "zod/v4";

export const getUploadBundlesStatus = {
  name: "getUploadBundlesStatus" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    finished: z.boolean(),
    failed: z.boolean().nullish(),
    noWorkflow: z.boolean().nullish(),
    dateCompleted: z.string().nullish(),
  }),
};
